module.exports = __webpack_public_path__ + "static/media/FMB_icon5.5847032f.svg";